import {AbstractVisualFeature} from '../../visual-feature.js';
import {StaticPages} from '../static-pages.js';

import {badRoutePageFactory} from './bad-route-page.js';

import PALETTE_SCHEMA from './bad-route-page.palette-schema.yaml';

class BadRoutePageFeature extends AbstractVisualFeature {
    get name() {
        return 'BadRoutePage';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return badRoutePageFactory(PALETTE);
    }
}

new BadRoutePageFeature(StaticPages);
